export const GET_FUNDS_LIST_PAN = "GET_FUNDS_LIST_PAN";
export const GET_FUNDS_LIST_PAN_SUCCESS = "GET_FUNDS_LIST_PAN_SUCCESS";
export const GET_FUNDS_LIST_PAN_FAILED = "GET_FUNDS_LIST_PAN_FAILED";
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_TRANSACTION_HISTORY_SUCCESS =
  "GET_TRANSACTION_HISTORY_SUCCESS";
export const GET_TRANSACTION_HISTORY_FAILED = "GET_TRANSACTION_HISTORY_FAILED";
export const GET_NAV_DATA = "GET_NAV_DATA";
export const GET_NAV_DATA_SUCCESS = "GET_NAV_DATA_SUCCESS";
export const GET_NAV_DATA_FAILED = "GET_NAV_DATA_FAILED";
export const REMOVE_NAV_DATA = "REMOVE_NAV_DATA";
export const CLEAR_TRANSACTION_HISTORY = "CLEAR_TRANSACTION_HISTORY";

export const GET_TRANSACTION_HISTORY_TRACK_DETAILS =
  "GET_TRANSACTION_HISTORY_TRACK_DETAILS";
export const GET_TRANSACTION_HISTORY_TRACK_DETAILS_SUCCESS =
  "GET_TRANSACTION_HISTORY_TRACK_DETAILS_SUCCESS";
export const GET_TRANSACTION_HISTORY_TRACK_DETAILS_FAILED =
  "GET_TRANSACTION_HISTORY_TRACK_DETAILS_FAILED";
